import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'
import fetchAPI from '../../../common/fetchAPI'
import { WebHookSenderLogStateClass } from './interfaces/WebHookSenderLogStateClass'
import { Search } from 'react-bootstrap-icons'

const initialState: WebHookSenderLogStateClass = {
    isLoading: false,
    status: 'idle',
    WebHookSenderLogList: [],
    selectedRecord: {},
    isReload: false,
    pageNo: 1,
    pageSize: 10,
    totalItems: 0,
    startRec: 0,
    search: " ",
    TargetURL: "",
    WebHookName:"",
    WebHookRequest: "",
    WebHookResponse: "",
    checkedRecordsArray: [],
    isAllUnChecked: true,
    recordsFiltered: 0,
    WebHookSenderLogCheckedIds: [],
    optionStatusValue:"All",
    optionStatusText:"All",
    optionWebHookEventTypeValue:"All",
    optionWebHookEventTypeText:"All",
    startDate:new Date().toISOString(),
    endDate:new Date().toISOString(),
    sortIndex:0,
    sortDirection:"asc",
    isSearch:false,
    isSort:false,
    // pageNo: 1,
    // startRec: 0,
    sortOrder: 'asc',
    sortColumn: '1',
    AccountWebhookSenderLogId: "",
    SearchParamsValues: ""
}
interface IThunkApi {
    state: {
        webHookSenderLog: WebHookSenderLogStateClass;
    },
}
export const getAccountWebHookSenderLogAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        // 'WebHookSenderLog/V2/getAccountWebHookSenderLog',
        // async (arg, thunkApi) => {
        //     const { currentPage, pageSize, start, search, SearchParamsValues, AccountWebhookSenderLogId,order,orderDir} = arg;
        //     const response = await fetchAPI('api/V2/Logs/WebhookSenderLogDatatable/' + currentPage + '/' + pageSize + '/' + start +'/'+ order +'/'+ orderDir + '/' + AccountWebhookSenderLogId  + '/' + SearchParamsValues + '/' +  search, 'Get', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
        //     const json = await response.json();
        //     return json;
        // }
        
        'WebHookSenderLog/V2/getAccountWebHookSenderLog',
        async (arg, thunkApi) => {
            const {pageNo, pageSize,startRec,sortColumn,sortOrder,AccountWebhookSenderLogId,SearchParamsValues, search } = thunkApi.getState().webHookSenderLog;
            const response = await fetchAPI(`api/V2/Logs/WebhookSenderLogDatatable/${pageNo}/${pageSize}/${startRec}/${sortColumn}/${sortOrder}/${AccountWebhookSenderLogId}/${SearchParamsValues}/${search}`, `Get`, '', true);
            const json = await response.json();
            return json;
       
        }
    )
export const getWebHookSenderLogAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'WebHookSenderLog/V2/getWebHookSenderLog',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/Logs/WebHookSender/' + arg, 'Get', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )
export const getWebhookRetryAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'WebHookSenderLog/V2/getWebhookRetry',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/Logs/Sender/Retry?SearchParamsValues=' + arg, 'Get', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )
    export const getHeadingAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'WebHookSenderLog/V2/getHeading',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/WebHooks/SubscriptionName/' + arg, 'Get', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )
export const webHookSenderLogSlice = createSlice({
    name: 'webHookSenderLog',
    initialState,
    reducers: {
        updatePagination: (state, action: PayloadAction<any>) => {
        state.startRec = action.payload.startRec;
        state.pageSize = action.payload.pageSize;
        state.pageNo = action.payload.pageNo;
        state.search = action.payload.search;
    },
    updateSearchPagination: (state, action: PayloadAction<any>) => {
        state.isSearch = state.isSearch ? false : true;
        state.search = action.payload;
    },
    updateSorting: (state, action: PayloadAction<any>) => {
        state.sortOrder = action.payload.sortOrder;
        state.sortColumn = action.payload.sortColumn;
        state.startRec = action.payload.startRec;
        state.pageSize = action.payload.pageSize;
        state.pageNo = action.payload.pageNo;
    },
        resetSelectedRecordObjectInState: (state) => {
            state.WebHookSenderLogList = [];
            state.WebHookSenderLogCheckedIds = [];
        },
        checkedState: (state, action) => {
            const currentindex = state.WebHookSenderLogList.findIndex((item) => item.AccountWebhookSenderLogId == action.payload);
            const newArray = [...state.WebHookSenderLogList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.WebHookSenderLogList = newArray;
            state.isAllUnChecked = false;
            state.WebHookSenderLogCheckedIds.push(newArray[currentindex].AccountWebhookSenderLogId);
        },
        unCheckedState: (state, action) => {
            const currentindex = state.WebHookSenderLogList.findIndex((item) => item.AccountWebhookSenderLogId == action.payload);
            const newArray = [...state.WebHookSenderLogList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.WebHookSenderLogList = newArray;
            state.WebHookSenderLogCheckedIds = state.WebHookSenderLogCheckedIds.filter(item => item !== newArray[currentindex].AccountWebhookSenderLogId);

            
        },
        checkedAllState: (state) => {
            const newArray = state.WebHookSenderLogList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.WebHookSenderLogList = newArray;
            state.isAllUnChecked = false;
            state.WebHookSenderLogList.map((i) => {
                if (!state.WebHookSenderLogCheckedIds.includes(i.AccountWebhookSenderLogId) && i.StatusCode !== 200 && i.StatusCode !== 202 && i.StatusCode !== 201) {
                    state.WebHookSenderLogCheckedIds.push(i.AccountWebhookSenderLogId)
                }
            });
        },
        unCheckedAllState: (state) => {
            const newArray = state.WebHookSenderLogList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.WebHookSenderLogList = newArray;
            state.isAllUnChecked = true;
            state.WebHookSenderLogList.map((i) => (
                state.WebHookSenderLogCheckedIds = state.WebHookSenderLogCheckedIds.filter(item => item !== i.AccountWebhookSenderLogId)
            ));
        },
        checkAllCheckboxIsUncheckedState: (state) => {
            state.isAllUnChecked = state.WebHookSenderLogList.every((item) => item.isSelected === 0);
            
        },
        setOptionStatusValue: (state, action) => {
            const {value,label} = action.payload;
            state.optionStatusValue = value;
            state.optionStatusText = label;
        },
        setOptionWebHookEventTypeValue: (state, action) => {
            const {value,label} = action.payload;
            state.optionWebHookEventTypeValue = value;
            state.optionWebHookEventTypeText = label;
        },
        setDateRangeValue: (state, action) => {
           const {startDate,endDate} = action.payload;
            state.startDate = startDate;
            state.endDate = endDate;
        },
       
        setSortConfig: (state, action) => {
            const {Index,Dir} = action.payload;
            state.sortDirection = Dir;
            state.sortIndex = Index;
           
         },
         setPageSize: (state, action) => {
            state.pageSize = action.payload;
         },
         setSearchValue: (state, action) => {

            state.search = action.payload;
            state.pageNo = 1;
        },

    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountWebHookSenderLogAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            // .addCase(getAccountWebHookSenderLogAsync.fulfilled, (state, { payload }) => {
            //     state.status = 'idle';
            //      console.log("Testing", payload);
            //      if (payload.Data.data !== undefined) {
            //         state.WebHookSenderLogList = Array.isArray(payload.Data.data) 
            //             ? payload.Data.data 
            //             : JSON.parse(payload.Data.data || '[]');
                
                    
            //         state.WebHookSenderLogList.map((item: any) => {
            //             if (state.WebHookSenderLogCheckedIds.includes(item.AccountWebhookSenderLogId)) {
            //                 item.isSelected = 1
            //             }
            //             else {
            //                 item.isSelected = 0
            //             }

            //         });

                    
            //         state.selectedRecord = {};
            //         state.pageNo = payload.Data.pageNo;
            //         state.startRec = payload.Data.startRec
            //         state.totalItems = payload.Data.recordsTotal;
            //         state.search = payload.Data.search;
            //         state.isReload = false;
            //         state.recordsFiltered = payload.Data.recordsFiltered;
            //         state.isSearch = false;
            //         state.isLoading = false;
            //         state.pageSize = payload.Data.pageSize;
            //         state.recordsFiltered = payload.Data.recordsFiltered;


            //     }
            // })
            .addCase(getAccountWebHookSenderLogAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                try {
                    let tempArray = JSON.parse(payload.Data.data)
                    if (tempArray.length > 0) {
                        state.selectedRecord = tempArray;
                    } else {
                        state.selectedRecord = {};
                    }
                    state.pageNo = payload.currentPage;
                    state.startRec = payload.start;
                    state.totalItems = payload.recordsTotal;
                    state.search = payload.search;
                    state.isReload = false;
                    state.recordsFiltered = payload.recordsFiltered;
                    state.isSearch = false;
                    state.isLoading = false;
                    state.pageSize = payload.pageSize;
                } catch (error) {
                    state.isLoading = false;
                    state.isReload = false;
                   state.isSearch = false;


                    // state.status = 'error';
                }
            })
          

            
            .addCase(getWebHookSenderLogAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getWebHookSenderLogAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.WebHookRequest = JSON.parse(payload.Data.WebHookRequest);
                state.WebHookResponse = payload.Data.WebHookResponse;
                state.TargetURL = payload.Data.TargetURL;
                
            })
            .addCase(getWebHookSenderLogAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(getWebhookRetryAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getWebhookRetryAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                
            })
            .addCase(getWebhookRetryAsync.rejected, (state) => {
                state.status = 'failed';
            })


            .addCase(getHeadingAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getHeadingAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
               
               state.WebHookName = payload.WebHookName;
               state.TargetURL = payload.TargetURL;
                

            })
            .addCase(getHeadingAsync.rejected, (state) => {
                state.status = 'failed';
            })

    }
})

export const {
    resetSelectedRecordObjectInState, checkedState, unCheckedState, checkedAllState, unCheckedAllState,updatePagination,updateSearchPagination,updateSorting, checkAllCheckboxIsUncheckedState,setSortConfig
    ,setDateRangeValue,setOptionStatusValue,setOptionWebHookEventTypeValue
} = webHookSenderLogSlice.actions
export const WebHookSenderLogState = (state: RootState) => state.webHookSenderLog
export default webHookSenderLogSlice.reducer
